/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateOrUpdateReimbursementRequestDto } from '../models/CreateOrUpdateReimbursementRequestDto';
import type { CreateOrUpdateTravelRequestDto } from '../models/CreateOrUpdateTravelRequestDto';
import type { CreateStipendRequestDto } from '../models/CreateStipendRequestDto';
import type { GetReimbursementRequestDto } from '../models/GetReimbursementRequestDto';
import type { GetStipendRequestDto } from '../models/GetStipendRequestDto';
import type { GetTravelRequestDto } from '../models/GetTravelRequestDto';
import type { ISaveStatus } from '../models/ISaveStatus';
import type { RequestCount } from '../models/RequestCount';
import type { RequestStatusDTO } from '../models/RequestStatusDTO';
import type { RequestSummaryViewModel } from '../models/RequestSummaryViewModel';
import type { TravelRequestTypeCountDto } from '../models/TravelRequestTypeCountDto';
import type { UpdateStipendRequestDto } from '../models/UpdateStipendRequestDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class RequestService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param id
     * @returns TravelRequestTypeCountDto
     * @throws ApiError
     */
    public requestGetActiveTravelRequestCountBySiteId(
        id: number,
    ): Observable<TravelRequestTypeCountDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/site/{id}/travel/active/count',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns RequestSummaryViewModel
     * @throws ApiError
     */
    public requestGetAllRequestSummaries(): Observable<Array<RequestSummaryViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/all/requestSummaries',
        });
    }
    /**
     * @param studyIds
     * @param visitNamesIds
     * @returns number
     * @throws ApiError
     */
    public requestGetAllRequestsCount(
        studyIds?: Array<number> | null,
        visitNamesIds?: Array<number> | null,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/all/count',
            query: {
                'studyIds': studyIds,
                'visitNamesIds': visitNamesIds,
            },
        });
    }
    /**
     * @param studyIds
     * @param visitNamesIds
     * @param expenseIds
     * @returns number
     * @throws ApiError
     */
    public requestGetAllReimbursementRequestsCount(
        studyIds?: Array<number> | null,
        visitNamesIds?: Array<number> | null,
        expenseIds?: Array<number> | null,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/all/reimbursement/count',
            query: {
                'studyIds': studyIds,
                'visitNamesIds': visitNamesIds,
                'expenseIds': expenseIds,
            },
        });
    }
    /**
     * @returns number
     * @throws ApiError
     */
    public requestGetAllRequestsDetailCount(): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/all/details/count',
        });
    }
    /**
     * @returns RequestCount
     * @throws ApiError
     */
    public requestGetTotalAllRequestsDetails(): Observable<Array<RequestCount>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/all/details/total',
        });
    }
    /**
     * @param requestId
     * @returns GetTravelRequestDto
     * @throws ApiError
     */
    public requestGetTravelRequest(
        requestId: number,
    ): Observable<GetTravelRequestDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/travel/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestUpdateTravelRequest(
        requestId: number,
        formData?: CreateOrUpdateTravelRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/travel/{requestId}',
            path: {
                'requestId': requestId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestId
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestDeleteTravelRequest(
        requestId: number,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/requests/travel/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @param attachmentId
     * @returns binary
     * @throws ApiError
     */
    public requestGetTravelRequestAttachment(
        requestId: number,
        attachmentId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/travel/{requestId}/attachment/{attachmentId}',
            path: {
                'requestId': requestId,
                'attachmentId': attachmentId,
            },
        });
    }
    /**
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestCreateTravelRequest(
        formData?: CreateOrUpdateTravelRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/requests/travel',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestCreateSubmitTravelRequest(
        formData?: CreateOrUpdateTravelRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/requests/travel/submit',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestId
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestUpdateCompleteTravelRequest(
        requestId: number,
        formData?: CreateOrUpdateTravelRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/travel/{requestId}/complete',
            path: {
                'requestId': requestId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestId
     * @returns GetReimbursementRequestDto
     * @throws ApiError
     */
    public requestGetReimbursementRequest(
        requestId: number,
    ): Observable<GetReimbursementRequestDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/reimbursement/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestUpdateReimbursementRequest(
        requestId: number,
        formData?: CreateOrUpdateReimbursementRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/reimbursement/{requestId}',
            path: {
                'requestId': requestId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestId
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestDeleteReimbursementRequest(
        requestId: number,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/requests/reimbursement/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @param attachmentId
     * @returns binary
     * @throws ApiError
     */
    public requestGetReimbursementRequestAttachment(
        requestId: number,
        attachmentId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/reimbursement/{requestId}/attachment/{attachmentId}',
            path: {
                'requestId': requestId,
                'attachmentId': attachmentId,
            },
        });
    }
    /**
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestCreateReimbursementRequest(
        formData?: CreateOrUpdateReimbursementRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/requests/reimbursement',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestCreateSubmitReimbursementRequest(
        formData?: CreateOrUpdateReimbursementRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/requests/reimbursement/submit',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestId
     * @param formData
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestUpdateCompleteReimbursementRequest(
        requestId: number,
        formData?: CreateOrUpdateReimbursementRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/reimbursement/{requestId}/complete',
            path: {
                'requestId': requestId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestId
     * @returns GetStipendRequestDto
     * @throws ApiError
     */
    public requestGetStipendRequest(
        requestId: number,
    ): Observable<GetStipendRequestDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/requests/stipend/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestDeleteStipendRequest(
        requestId: number,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/requests/stipend/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestCreateStipendRequest(
        requestBody: CreateStipendRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/requests/stipend',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestUpdateStipendRequest(
        requestBody: UpdateStipendRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/stipend',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestCreateSubmitStipendRequest(
        requestBody: CreateStipendRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/requests/stipend/submit',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestUpdateSubmitStipendRequest(
        requestBody: UpdateStipendRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/stipend/submit',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestCreateCompleteStipendRequest(
        requestBody: CreateStipendRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/requests/stipend/complete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestUpdateCompleteStipendRequest(
        requestBody: UpdateStipendRequestDto,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/stipend/complete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestId
     * @param caregiverId
     * @returns binary
     * @throws ApiError
     */
    public requestDeleteTravelRequestCaregiver(
        requestId: number,
        caregiverId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/requests/travel/{requestId}/caregiver/{caregiverId}',
            path: {
                'requestId': requestId,
                'caregiverId': caregiverId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestChangeTravelRequestStatus(
        requestBody: RequestStatusDTO,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/travel/changestatus',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestChangeStipendRequestStatus(
        requestBody: RequestStatusDTO,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/stipend/changestatus',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public requestChangeReimbursementRequestStatus(
        requestBody: RequestStatusDTO,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/requests/reimbursement/changestatus',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
